// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d03b6bae2efb3e1fee9bfeb12283830a78e4b5a3/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};